import React, { useState, useEffect } from "react";
import { UserPlus, X, Users, Mail } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CoOrganizersSection = ({ eventId }) => {
  const [coOrgs, setCoOrgs] = useState([]);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchCoOrgs = async () => {
    try {
      const token = localStorage.getItem("tika_organizer_token");
      const res = await axios.get(`${API}/organizer/events/${eventId}/co-organizers`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCoOrgs(res.data || []);
    } catch (err) {
      console.error("Erreur co-organisateurs:", err);
    }
  };

  useEffect(() => {
    if (eventId) fetchCoOrgs();
  }, [eventId]);

  const handleInvite = async () => {
    if (!email.trim()) return;
    setLoading(true);
    try {
      const token = localStorage.getItem("tika_organizer_token");
      const res = await axios.post(
        `${API}/organizer/events/${eventId}/co-organizers`,
        { email: email.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(res.data.message);
      setEmail("");
      fetchCoOrgs();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur lors de l'ajout");
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (coOrgId, name) => {
    if (!window.confirm(`Retirer ${name} de la co-organisation ?`)) return;
    try {
      const token = localStorage.getItem("tika_organizer_token");
      await axios.delete(`${API}/organizer/events/${eventId}/co-organizers/${coOrgId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Co-organisateur retiré");
      fetchCoOrgs();
    } catch (err) {
      toast.error("Erreur lors du retrait");
    }
  };

  return (
    <div className="glass-card rounded-lg p-4 border border-primary/20" data-testid="co-organizers-section">
      <div className="flex items-center gap-2 mb-3">
        <Users className="w-4 h-4 text-primary" />
        <h4 className="font-medium text-sm">Co-organisateurs</h4>
      </div>

      {coOrgs.length > 0 && (
        <div className="space-y-2 mb-3">
          {coOrgs.map((co) => (
            <div key={co.id} className="flex items-center justify-between bg-muted/20 rounded-lg px-3 py-2">
              <div className="min-w-0">
                <p className="text-sm font-medium truncate">{co.name || co.company_name}</p>
                <p className="text-xs text-muted-foreground truncate">{co.email}</p>
              </div>
              <Button variant="ghost" size="icon" className="h-7 w-7 flex-shrink-0" onClick={() => handleRemove(co.id, co.name)}>
                <X className="w-3 h-3" />
              </Button>
            </div>
          ))}
        </div>
      )}

      <div className="flex gap-2">
        <div className="relative flex-1">
          <Mail className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-muted-foreground" />
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email de l'organisateur"
            className="pl-8 text-sm h-9"
            data-testid="co-org-email-input"
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleInvite(); } }}
          />
        </div>
        <Button type="button" size="sm" disabled={loading || !email.trim()} className="h-9" data-testid="co-org-invite-btn" onClick={handleInvite}>
          <UserPlus className="w-3.5 h-3.5 mr-1" />
          {loading ? "..." : "Ajouter"}
        </Button>
      </div>
      <p className="text-xs text-muted-foreground mt-2">
        Le co-organisateur doit avoir un compte organisateur TIKA.
      </p>
    </div>
  );
};
